import chroma from "chroma-js";
import { type LeafletEventHandlerFnMap, type LeafletMouseEvent } from "leaflet";

const hiddenProperties = new Set(["color", "weight", "id"]);
export const heatmapScale = chroma.scale(["FFDA91", "CF3A3A"]);

const onCreateLinePopup = (event: LeafletMouseEvent): void => {
  const { properties } = event.sourceTarget.feature;
  let propertyString = "";

  for (const property of Object.keys(properties).filter((property) => !hiddenProperties.has(property))) {
    propertyString += `<strong>${property}:</strong> ${properties[property]} <br>`;
  }

  event.propagatedFrom.bindPopup(`<p>${propertyString}</p>`);
};

export function leafletFlowMapEventMap(): LeafletEventHandlerFnMap {
  return {
    click: (event: LeafletMouseEvent) => {
      onCreateLinePopup(event);
    },
    mouseover: (event: LeafletMouseEvent) => {
      onCreateLinePopup(event);
    },
    mouseout: (event: LeafletMouseEvent) => event.propagatedFrom.closePopup(),
    contextmenu: (event: LeafletMouseEvent) => {
      onCreateLinePopup(event);
    },
  };
}

export function logarithmicThicknessFunction(frequency: number): number {
  return Math.ceil(Math.log((frequency ?? 0) + 1)) * 3;
}

export function defaultThicknessFunction(freq: number, maxFrequency: number): number {
  const frequency = freq ?? 0;
  const scaleNr = maxFrequency === 0 ? 0 : frequency / maxFrequency;
  return scaleNr * 10 + 1;
}

export function logarithmicThicknessFunctionWithZoom(freq: number, __: number, zoomMultiplicator: number): number {
  return Math.ceil(Math.log((freq ?? 0) + 1)) * 3 * zoomMultiplicator;
}

export function defaultColoringFunction(freq: number, maxFrequency: number): string {
  const frequency = freq ?? 0;
  const scaleNr = maxFrequency === 0 ? 0 : frequency / maxFrequency;
  const color = heatmapScale(scaleNr);
  return color.hex();
}
